{
  "errors": {
    "noBulletins": "Ei tiedotteita",
    "bulletinsFetchError": "Virhe haettaessa tiedotteita",
    "errorLoadingBulletin": "Virhe tiedotteen haussa. Yritä myöhemmin uudelleen."
  },
  "edited": "Muokattu"
}
